var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDinner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dinner",
    transform: "translate(-28 -145)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7485",
    "data-name": "Rectangle 7485",
    width: 40,
    height: 40,
    rx: 20,
    transform: "translate(28 145)",
    fill: "#fef0e7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x30_7_x2C__dinner_x2C__dinner_table_x2C__party_x2C__dine_x2C__food_and_restaurant",
    transform: "translate(36 110)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_537_",
    transform: "translate(1 46)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_538_",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_539_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_540_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_498_",
    d: "M81.425,169.822H95.439a.425.425,0,0,0,.425-.425v-1.7a1.7,1.7,0,0,0-1.7-1.7H82.7a1.7,1.7,0,0,0-1.7,1.7v1.7A.425.425,0,0,0,81.425,169.822Z",
    transform: "translate(-77.602 -160.904)",
    fill: "#f37021"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_497_",
    d: "M236,283.644a.425.425,0,0,0,.425.425h.849a.425.425,0,0,0,.425-.425V276H236Z",
    transform: "translate(-226.02 -266.232)",
    fill: "#f37021"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_496_",
    d: "M1,360.247a.425.425,0,0,0,.425.425h.849a.425.425,0,0,0,.425-.425V356H1Z",
    transform: "translate(-1 -342.835)",
    fill: "#f37021"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_495_",
    d: "M141,360.247a.425.425,0,0,0,.425.425h.849a.425.425,0,0,0,.425-.425V356H141Z",
    transform: "translate(-135.054 -342.835)",
    fill: "#f37021"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_494_",
    d: "M331,360.247a.425.425,0,0,0,.425.425h.849a.425.425,0,0,0,.425-.425V356H331Z",
    transform: "translate(-316.985 -342.835)",
    fill: "#f37021"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_493_",
    d: "M471,360.247a.425.425,0,0,0,.425.425h.849a.425.425,0,0,0,.425-.425V356H471Z",
    transform: "translate(-451.04 -342.835)",
    fill: "#f37021"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_492_",
    d: "M111.849,49.324v.922h.849v-.922a1.276,1.276,0,0,0,.849-1.2v-1.7a.425.425,0,0,0-.425-.425h-1.7a.425.425,0,0,0-.425.425v1.7A1.276,1.276,0,0,0,111.849,49.324Z",
    transform: "translate(-106.328 -46)",
    fill: "#f37021"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_491_",
    d: "M341.849,49.324v.922h.849v-.922a1.276,1.276,0,0,0,.849-1.2v-1.7a.425.425,0,0,0-.425-.425h-1.7a.425.425,0,0,0-.425.425v1.7A1.276,1.276,0,0,0,341.849,49.324Z",
    transform: "translate(-326.561 -46)",
    fill: "#f37021"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_490_",
    d: "M338.22,76h-.849a1.274,1.274,0,0,0-1.274,1.274v7.22h-3.822A1.274,1.274,0,0,0,331,85.768v.849a.425.425,0,0,0,.425.425h6.8a.425.425,0,0,0,.425-.425V76.425A.425.425,0,0,0,338.22,76Z",
    transform: "translate(-316.985 -74.726)",
    fill: "#f37021"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_489_",
    d: "M7.37,84.494H3.548v-7.22A1.274,1.274,0,0,0,2.274,76H1.425A.425.425,0,0,0,1,76.425V86.617a.425.425,0,0,0,.425.425h6.8a.425.425,0,0,0,.425-.425v-.849A1.274,1.274,0,0,0,7.37,84.494Z",
    transform: "translate(-1 -74.726)",
    fill: "#f37021"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_488_",
    d: "M201.1,59.4a2.548,2.548,0,0,0-2.123-2.512v-.461a.425.425,0,1,0-.849,0v.461A2.548,2.548,0,0,0,196,59.4v.425h5.1Z",
    transform: "translate(-187.719 -55.575)",
    fill: "#f37021"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDinner);
export default __webpack_public_path__ + "static/media/dinner.c5c1ad8e9e6c2a6313d655a5241d5403.svg";
export { ForwardRef as ReactComponent };